
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Task } from '@/types/task';
import { useToast } from '@/hooks/use-toast';

export const useEditTaskMutation = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ taskId, data }: { taskId: string; data: Partial<Task> }) => {
      const { data: updatedTask, error } = await supabase
        .from('tasks')
        .update({
          title: data.title,
          description: data.description,
          hebrew_title: data.hebrewTitle,
          hebrew_description: data.hebrewDescription,
          scheduled_day: data.scheduledDay,
          scheduled_hour: data.scheduledHour,
          scheduled_minute: data.scheduledMinute,
          coins: data.coins,
          is_completed: data.isCompleted,
        })
        .eq('id', taskId)
        .select()
        .single();

      if (error) throw error;
      return updatedTask;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
      toast({
        title: "Task Updated",
        description: "Your task has been updated successfully!",
      });
    },
    onError: (error) => {
      console.error('Error updating task:', error);
      toast({
        title: "Error",
        description: "Failed to update task. Please try again.",
        variant: "destructive",
      });
    }
  });
};
